import React from "react";
import PropTypes from "prop-types";
import { Card } from "react-bootstrap";

export default function DashBoardPanel(props) {
  return (
    <Card>
      <Card.Body>
        <Card.Title>{props.title}</Card.Title>
        {props.children}
      </Card.Body>
    </Card>
  );
}

DashBoardPanel.propTypes = {
  title: PropTypes.string.isRequired
};